import React from "react";
import { Link } from "react-router-dom";
import "../Css/Slide1.css";

export const Navbar = () => {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark mt-4 shadow-5-strong">
        <div className="container">
          <Link
            className="navbar-brand text-light "
            to="/"
            style={{ fontWeight: "bold" }}
          >
            WDSchool
          </Link>

          <button
            className="navbar-toggler "
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="true"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon "></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav">
              <li className="nav-item" style={{ paddingLeft: "20px" }}>
                <a className="nav-link active" aria-current="page" href="/">
                  Home
                </a>
              </li>
              <li className="nav-item dropdown" style={{ paddingLeft: "20px" }}>
                <a
                  className="nav-link active dropdown-toggle"
                  href=""
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Course
                </a>

                <ul className="dropdown-menu bg-dark ">
                  <li>
                    <Link
                      className="dropdown-item text-light "
                      to="/Pythontrainning"
                    >
                      Python Trainning
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item  text-light"
                      to="/Nodetrainning"
                    >
                      NodeJS Trainning
                    </Link>
                  </li>
                  {/* <li>
                    <a className="dropdown-item  text-light" href="#">
                      Javascript Trainning
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item  text-light" href="#">
                      Html Trainning
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item  text-light" href="#">
                      Css Trainning
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item  text-light" href="#">
                      ReactJs Trainning
                    </a>
                  </li> */}
                </ul>
              </li>
              <li className="nav-item" style={{ paddingLeft: "20px" }}>
                <a className="nav-link active" href="">
                  Practice Papers
                </a>
              </li>
              <li className="nav-item" style={{ paddingLeft: "20px" }}>
                <a className="nav-link active " href="">
                  Contact US
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};
